// if they have host info, show info screen
// if they are SS or Diamond they just show the hotline number
import ConnectedVIPHostInfoHotline from 'containers/VIPHostInfoHotline';

export default function VIPHostInfoHotlineScreen() {
  return <ConnectedVIPHostInfoHotline />;
}
